// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBox-cls1_Xrm","cls2":"SearchBox-cls2_kwX SearchBox-cls1_Xrm"};